module.exports = "/newsfeed/components/newsfeed-search-route-3fb401.html";